<template>
  <QuoteUpload
    :disable="saving || isExistingQuoteOpen"
    :quoteFile="quoteUpload.quoteFile"
    :odometer="customerOptions.odometer"
    :car-price="customerOptions.carPrice"
    :registrationNumber="customerOptions.registrationNumber"
    :errors="$v"
    :file-interaction="gettingQuoteFile || savingQuoteFile"
    :display-used-car-fields="!isNew"
    :happy-with-quote-loading="happyWithQuoteLoading"
    :find-better-quote-loading="findBetterQuoteLoading"
    :no-quote-loading="noQuoteLoading"
    :car-price-tip="carPriceTip"
    @update:odometer="updateField('odometer', $event)"
    @update:car-price="updateField('carPrice', $event)"
    @update:registration-number="updateField('registrationNumber', $event)"
    @update:quote-file="updateQuoteFile"
    @click:request-better-quote="
      continueWithQuote(
        $Constants.UPLOAD_QUOTE_COMPLETE_STATUSES.requestBetterQuote
      )
    "
    @click:happy-with-quote="
      continueWithQuote(
        $Constants.UPLOAD_QUOTE_COMPLETE_STATUSES.happyWithQuote
      )
    "
    @click:no-quote-file="noQuoteFile"
  />
</template>

<script>
import { mapMutations, mapState, mapGetters, mapActions } from 'vuex';
import validations from './validations';

export default {
  name: 'QuoteUploadWidget',
  metaInfo: {
    title: 'Quote Upload |'
  },
  data() {
    return {
      noQuoteLoading: false,
      updateApplicationPaths:
        this.$Constants.APPLICATION_UPDATE_PATHS.quoteUpload
    };
  },
  validations,
  computed: {
    ...mapState({
      quote: (state) => state.quote.quote,
      quoteSaving: (state) => state.quote.savingQuote,
      applicationSaving: (state) => state.application.applicationSaving,
      quoteUpload: (state) =>
        state.application.application.metaData.quoteUpload || {},
      savingQuoteFile: (state) => state.application.savingQuoteFile || false,
      gettingQuoteFile: (state) => state.application.gettingQuoteFile || false,
      customerOptions: (state) =>
        state.application.application.metaData.customerOptions || {}
    }),
    ...mapGetters('carSearch', ['getNewUsedList', 'isNew']),
    ...mapGetters('quote', ['isExistingQuoteOpen']),
    happyWithQuote() {
      return this.quoteUpload[
        this.$Constants.UPLOAD_QUOTE_COMPLETE_STATUSES.happyWithQuote
      ];
    },
    requestBetterQuote() {
      return this.quoteUpload[
        this.$Constants.UPLOAD_QUOTE_COMPLETE_STATUSES.requestBetterQuote
      ];
    },
    saving() {
      return this.applicationSaving || this.quoteSaving;
    },
    happyWithQuoteLoading() {
      return this.saving && this.happyWithQuote;
    },
    findBetterQuoteLoading() {
      return this.saving && this.requestBetterQuote;
    },
    carPriceTip() {
      const price =
        this.$Constants.UPLOAD_QUOTE_MIN_CAR_COST[
          this.customerOptions.vehicleCondition
        ];
      return price
        ? `The minimum finance application for a used vehicle is ${this.$options.filters.currency(
            price
          )}`
        : undefined;
    }
  },
  methods: {
    ...mapMutations('application', [
      'updateQuoteUpload',
      'updateCustomerOption'
    ]),
    ...mapActions('application', [
      'saveQuoteFile',
      'updateApplication',
      'getQuoteFile'
    ]),
    ...mapActions('quote', ['createQuote']),
    updateField(field, value) {
      this.updateCustomerOption({
        field,
        value
      });
    },
    async updateQuoteFile(value) {
      value
        ? await this.saveQuoteFile(value)
        : await this.updateQuoteUpload({ field: 'quoteFile', undefined });

      await this.updateApplication({
        updateApplicationPaths: this.updateApplicationPaths,
        quoteFile: value
      });
    },
    async continueWithQuote(continueField) {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      await this.updateQuoteUpload({
        field: continueField,
        value: true
      });
      // Create quote also saves the application
      await this.createQuote({
        componentContext: this,
        updateApplicationPaths: this.updateApplicationPaths
      });
      await this.goToQuoteUploaded();
    },
    async noQuoteFile() {
      if (!this.quoteUpload.quoteFile) {
        return this.goToCarSearch();
      }

      this.noQuoteLoading = true;
      await this.updateQuoteUpload({ field: 'quoteFile', undefined });
      await this.updateApplication({
        updateApplicationPaths: this.updateApplicationPaths
      });
      this.noQuoteLoading = false;
      return this.goToCarSearch();
    },
    goToCarSearch() {
      this.$router.push({ name: this.$RouteNames.carSearchVariant });
    },
    goToQuoteUploaded() {
      this.$router.push({
        name: this.$RouteNames.dealerPrice,
        params: { quoteId: this.quote.quoteId }
      });
    }
  },
  mounted() {
    this.updateQuoteUpload({
      field: 'uploadQuoteType',
      value: this.$Constants.UPLOAD_QUOTE_TYPES
    });

    if (this.quoteUpload.quoteFile) {
      this.getQuoteFile(this.quoteUpload.quoteFile);
    }
  },
  components: {
    QuoteUpload: () => import('../../components/page/quote-upload')
  }
};
</script>
